import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "hide-overflow" }
const _hoisted_2 = { class: "content-padding" }
const _hoisted_3 = {
  key: 0,
  class: "text-center titles-1"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center titles-2"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["id", "onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-center signed-background-color text-font" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "text-center unsigned-background-color text-font" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-center h2-doc-name" }
const _hoisted_13 = { class: "h2-member-name" }
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_vue3_signature = _resolveComponent("vue3-signature")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "orange" }, [
      _createElementVNode("div", { class: "width-100" }, [
        _createElementVNode("img", {
          class: "maxsize",
          src: "https://storage.googleapis.com/storage-public-images/logos/movida-white.png"
        })
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              (_ctx.title_size)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.process_name), 1))
                : (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.process_name), 1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (this.are_there_docs)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("h2", { class: "text-center titles-2" }, "Documentos a assinar", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.are_there_docs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signature_process?.signature_documents, (document, document_index) => {
              return (_openBlock(), _createElementBlock("div", { key: document_index }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(document.members, (member, member_index) => {
                  return (_openBlock(), _createBlock(_component_v_row, {
                    id: "members-list",
                    key: member_index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", {
                            class: "text-center text-font clickable",
                            id: 'docp-' + document_index + '-' + member_index,
                            onClick: ($event: any) => (_ctx.getPdf(document.id, 'docp-' + document_index + '-' + member_index))
                          }, _toDisplayString(document.name), 9, _hoisted_6)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          (member.signature_file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("p", _hoisted_8, " Assinante: " + _toDisplayString(member.name) + " " + _toDisplayString(member.document.length > 1 ? "- " + member.document : "") + " - Assinado em " + _toDisplayString(member.updated_at), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("p", _hoisted_10, " Assinante: " + _toDisplayString(member.name) + " " + _toDisplayString(member.document.length > 1 ? "- " + member.document : ""), 1)
                              ]))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
            }), 128)),
            _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.show_signe_finish_buttons)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.unsigned_docs)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "actionBtn",
                id: "btn-assinar",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signeIt && _ctx.signeIt(...args)))
              }, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("b", null, "Assinar", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: _normalizeClass(["actionBtn", { 'disabled-btn': _ctx.disable_finish_button }]),
                id: "btn-finalizar",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.finishSignatureProcess && _ctx.finishSignatureProcess(...args)))
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("b", null, "Finalizar", -1)
              ]))], 2))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.modal_open,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modal_open) = $event)),
          "onClick:outside": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modal_open = false)),
          width: "auto",
          "content-class": "dialog-model-content",
          scrollable: "",
          transition: "dialog-bottom-transition"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, { class: "modal-background-color" }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_12, _toDisplayString(this.doc_name), 1),
                _createVNode(_component_vue3_signature, {
                  class: "signature-panel",
                  w: _ctx.signature_width,
                  h: _ctx.signature_height,
                  sigOption: _ctx.state.option,
                  disabled: _ctx.state.disabled,
                  ref: "signature_ref"
                }, null, 8, ["w", "h", "sigOption", "disabled"]),
                _createVNode(_component_v_container, { class: "text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { justify: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", _hoisted_13, _toDisplayString(this.member_name), 1),
                            (this.member_doc.length > 1)
                              ? (_openBlock(), _createElementBlock("h2", _hoisted_14, _toDisplayString(this.member_doc), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { justify: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            (_ctx.show_back_button)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  class: "sig-margin",
                                  color: "white",
                                  onClick: _ctx.previousSignature
                                }, {
                                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createTextVNode("Voltar", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_btn, {
                              class: "sig-margin",
                              color: "white",
                              onClick: _ctx.clear
                            }, {
                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode("Limpar assinatura", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              class: "sig-margin",
                              color: "#ff5000",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveSignature('image/jpeg')))
                            }, {
                              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                _createTextVNode("Salvar assinatura", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.snackbar) = $event)),
      timeout: _ctx.timeout
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "text",
          onClick: _ctx.closeSnack
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createTextVNode(" Fechar ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_icon, { class: "ml-1" }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode(" mdi-information-outline ", -1)
          ]))]),
          _: 1
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.snackbar_text) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "timeout"])
  ]))
}